

import React from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import $ from 'jquery'
import logo from '../parker-logo.png';
import logo1 from '../loader.gif';

const Home = props => (<div></div>);

class ReportContainer extends React.Component {
  render() {
    return (
      <div>
        <div id="reportContainer" style={{ width: '100%', float: 'left', height: '90vh' }}></div>
      </div>
    );
  }
}

ReactDOM.render(<ReportContainer />, document.getElementById('root'));

class App extends React.Component {
  render() {
    return (
      <img alt="Parker" className="logo" src={logo} style={{ height: '45px', width: '101px' }} />
    );
  }
}

ReactDOM.render(<App />, document.getElementById('logo1'));

class Loader extends React.Component {
  render() {
    return (
      <img alt="Parker" className="logo" src={logo1} />
    );
  }
}
ReactDOM.render(<Loader />, document.getElementById('loadingmessage'));

class ExportAlert extends React.Component {
  render() {
    return (
      <div id="exporttext" className="export-text">
        <div className="export-loader"></div>
        <div className="loader-text">
          <strong>Export to PDF in progress</strong><br /><br />

          <span>Your report is being exported to a PDF file.</span><br />
          <span>This might take a few minutes</span>
        </div>
      </div>
    );
  }
}
ReactDOM.render(<ExportAlert />, document.getElementById('exportalert'));

class Reportmenu extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      posts: []
    };
  }
  fetchFirst(url) {
    var that = this;
    if (url) {

      let items = [];

      $.post("Powerbiauth/FunGetOrgDetails", {
        StrLocReportName: "",
        StrLocUserId: getQueryVariable("UserId"),
        StrLocOrgId: getQueryVariable("OrgId"),
        StrLoctoken: getQueryVariable("token"),
        supportmode: getQueryVariable("supportmode")

      }, function (data, status) {
        try {
          that.setState({ posts: data });
          if (data.orgAccess == false) {
            window.alert("You don't have permission to view report");
          }
          if (data.orgAccess == true) {

            if (data.orgReportsMap.fleetsummaryv2 == true) {
              items.push(<li key="fleetsummaryv2" className="dropdown"><a><span className="bordered" reportname="FleetSummaryV2">Fleet Summary</span></a></li>);
            }
            else if (data.orgReportsMap.fleetsummaryv1 == true) {
              items.push(<li key="summary" className="dropdown"><a><span className="bordered" reportname="Summary">Summary</span></a></li>);
            }

            if (data.orgReportsMap.operations == true) {
              items.push(<li key="operations" className="dropdown"><a><span reportname="Operations">Operations</span></a></li>);
            }
            if (data.orgReportsMap.health == true) {
              items.push(<li key="health" className="dropdown"><a><span reportname="Health">Health</span></a></li>);
            }
            if (data.orgReportsMap.impact == true) {
              items.push(<li key="impact" className="dropdown"><a><span reportname="Impact">Impact</span></a></li>);
            }
            if (data.orgReportsMap.lifts == true) {
              items.push(<li key="lifts" className="dropdown"><a><span reportname="Lifts">Lifts</span></a></li>);
            }
            if (data.orgReportsMap.epto_extended == true) {
              items.push(<li key="epto_extended" className="dropdown"><a><span reportname="ePTOExtended">ePTO V2</span></a></li>);
            }
            if (data.orgReportsMap.epto == true) {
              items.push(<li key="epto" className="dropdown"><a><span reportname="ePTO">ePTO</span></a></li>);
            }
            if (data.orgReportsMap.px == true) {
              items.push(<li key="px" className="dropdown"><a><span reportname="PX">PX</span></a></li>);
            }
            if (data.orgReportsMap.soc == true) {
              items.push(<li key="soc" className="dropdown"><a><span reportname="SOC">SOC</span></a></li>);
            }
            if (data.orgReportsMap.gatewayservice == true) {
              items.push(<li key="gatewayservice" className="dropdown"><a><span reportname="GatewayService">Gateway</span></a></li>);
            }
            if (data.orgReportsMap.iqanbilling == true) {
              items.push(<li key="iqanbilling" className="dropdown"><a><span reportname="IQANBilling">OTA</span></a></li>);
            }
          }
          that.setState({ table: items });
        } catch (e) {
          console.log("Error Home Page: " + e);
        }
      }, 'json').fail(function (response) {
        window.showReportAccessError(response);
      });
    }
  }

  componentWillMount() {
    this.fetchFirst("reactjs");
  }
  componentDidUpdate() {
    if (this.state.posts.length == undefined) {
      window.funready(this.state.posts);
    }
    // set el height and width etc.
  }
  render() {
    if (this.state.posts.length == undefined) {
      return (
        <ul className="nav navbar-nav border_color">
          {this.state.table}
        </ul>
      );
    }

    return (
      <div></div>
    );
  }
}

ReactDOM.render(<Reportmenu />, document.getElementById('navigations'));

export default connect()(Home);

function getQueryVariable(variable) {
  if (window.getReportLaunchParameter) return window.getReportLaunchParameter(variable);
  var queryParams = new URLSearchParams(window.location.search);
  var result = queryParams.get(variable);
  if (result === null) {
    return false;
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/components/Home.js